import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Dropdown, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { logoutUser, setDefaultRole } from '../../store/actions/users/usersActions';

import { Cache } from 'aws-amplify';

class Header extends Component {
  constructor(props) {
    super(props);
    this.defaultRole = '';
  }
  getRoles = () => {
    const roles = this.props.users.currentUser.roles;
    const roleId = Cache.getItem('roleId');
    let rolesOption, firstRole;
    if (typeof(roles) !== "undefined") {
      rolesOption = roles.length && roles.map((role, key) => {
        if (key === 0) {
          firstRole = role;
        }

        if (roleId && roleId === role.id) {
          this.defaultRole = role;
        }

        return (
          <option key={key} value={role.id}>{role.role_name}</option>
        )
      })
    }

    if (!this.defaultRole) {
      this.defaultRole = firstRole;
    }

    return rolesOption;
  }

  render() {
    let firstName = '';
    let lastName = '';
    let roles = '';
    const currentUser = this.props.users.currentUser;
    
    if (typeof(currentUser) !== "undefined") {
      firstName = currentUser.first_name;
      lastName = currentUser.last_name;
      roles = currentUser.roles;
    }

    return (
      <Row id="app-title" className="align-left">
        <Col xs={9} sm={9} md={9} lg={9} xl={9}>
          <h3>Time Tracking Tool</h3>
        </Col>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}>
          <Dropdown alignRight id="user-burger-menu"> 
              <Dropdown.Toggle id="user-burger-menu_button">
                {lastName}, {firstName}
              </Dropdown.Toggle>
              <Dropdown.Menu id="user-burger-menu-dropdown" className="super-colors">
                  <Dropdown.Header>
                    <div>Roles:</div>
                    <Form.Control 
                      defaultValue={Cache.getItem('roleId')}
                      size="sm" 
                      as="select" 
                      onChange={(e) => {
                        const roleId = e.target.value;
                        roles.filter(data => {
                          if (data.id === parseInt(roleId)) {
                            return data;
                          }
                          return null;
                        }).map((role) => {
                          return this.props.setDefaultRole(role);
                        });

                        this.props.history.push('/dashboard');

                      }}
                    >
                      { this.getRoles() }
                    </Form.Control>
                  </Dropdown.Header>
                  <Dropdown.Divider />
                  {/* <Dropdown.Item onClick={() => {
                      this.props.history.push('/profile');
                  }}>
                      <FontAwesomeIcon icon={faUser} /> My Profile
                  </Dropdown.Item> */}
                  <Dropdown.Item onClick={() => {
                      this.props.history.push('/users/change-password');
                  }}>
                      <FontAwesomeIcon icon={faUser} /> Change Password
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => {
                    this.props.logoutUser(() => {
                      this.props.history.push('/');
                    });
                  }}>
                      <FontAwesomeIcon icon={faSignOutAlt} flip="horizontal" /> Logout
                  </Dropdown.Item>
              </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
    )
  }
}

const mapStateToProps = (state) => ({
  users: state.users
})

const mapDispatchToProps = (dispatch) => {
  return {
    logoutUser: (...args) => dispatch(logoutUser(...args)),
    setDefaultRole: (...args) => dispatch(setDefaultRole(...args))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
